import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { SubHeading } from './investors/components';
import { IsOutBoundFundFlow } from '../utils/utilityFunctions';
import { useSelector } from 'react-redux';
import { RootStateType } from '../redux-store/reducers';

const Officially_Valid_Document =
  'Document shall be deemed to be an Officially Valid Document even if there is a change in the name subsequent to its issuance, provided it is supported by a marriage certificate issued by the State Government or Gazette notification, indicating such a change of name.';

const OVD_Certificate =
  'Where certification of an OVD is done by the authorized officer of the Regulated Entity, such certified copy should be dated, signed and marked with ‘original sighted/verified’.';

const OVD_Contactable = 'The person certifying the OVD should be contactable.';

export const DocumentDeclaration =
  'I acknowledge that all of the measures mentioned above are taken.';

const styles = {
  content: {
    fontSize: 14,
    py: 1,
  },
  list: {
    fontSize: 14,
    py: 0.5,
  },
};

const Ol = ({
  children,
  style,
  type,
}: {
  children: JSX.Element;
  style?: any;
  type?: '1' | 'a' | 'i' | 'A' | 'I';
}) => {
  return (
    <Typography component={'ol'} style={style} type={type}>
      {children}
    </Typography>
  );
};
const JustifiedText = ({
  children,
  style,
  component = Typography,
}: {
  children: JSX.Element;
  style?: any;
  component?: React.ElementType;
}) => {
  return (
    <Typography
      sx={{
        textAlign: 'justify',
        //  ...styles.content
      }}
      style={style}
      component={component}>
      {children}
    </Typography>
  );
};
const Li = ({
  children,
  style,
}: {
  children: JSX.Element;
  style?: any;
  component?: React.ElementType;
}) => {
  return (
    <Typography
      sx={{
        textAlign: 'justify',
        //     ...styles.content,
        //     ...style,
      }}
      component={'li'}>
      {children}
    </Typography>
  );
};

const OriginalDocument = () => {
  const { application } = useSelector((store: RootStateType) => store.application);
  return (
    <>
      <JustifiedText>
        <>
          In case a customer is unable to produce, or it might not be possible for customer to
          submit original documents for verification (e.g., in situations where Regulated Entity has
          no physical contact with the customer, or the onboarding of customer is done through
          non-face to face mode); a Regulated Entity should obtain a copy of the OVD that is
          certified to be a ‘true copy’ and such certification may be carried out by any one of the
          following:
        </>
      </JustifiedText>
      {IsOutBoundFundFlow(application?.fundFlowType || '') && (
        <JustifiedText>
          <>
            For Resident Individuals and Indian Entities, MFDs can authenticate documents; for other
            investors, authentication must be done by authorized personnel as per regulations which
            are as mentioned below.
          </>
        </JustifiedText>
      )}
      <Ol type="a">
        <>
          <Li>
            <>
              Authorised official of a bank located in a Financial Action Task Force (FATF)
              compliant jurisdiction with whom the individual has banking relationship;
            </>
          </Li>
          <Li>
            <>Notary Public (outside India);</>
          </Li>
          <Li>
            <>Court Magistrate (outside India);</>
          </Li>
          <Li>
            <>Judge (outside India);</>
          </Li>
          <Li>
            <>Certified public or professional accountant (outside India);</>
          </Li>
          <Li>
            <>Lawyer (outside India);</>
          </Li>
          <Li>
            <>
              The Embassy/Consulate General of the country of which the non-resident individual is a
              citizen; or
            </>
          </Li>
          <Li>
            <>any other authority as may be specified by the Authority.</>
          </Li>
        </>
      </Ol>
    </>
  );
};

const SubHeading2 = styled(SubHeading)(({ theme }) => ({
  backgroundColor: 'rgba(211, 47, 47, 0.1)',
  color: 'rgb(211, 47, 47)',
}));

export const IFSCGuidlines = () => {
  return (
    <Grid sx={{ width: '100%' }}>
      <SubHeading2>As per latest Guidelines of IFSC</SubHeading2>
      <Ol>
        <>
          <Li>
            <OriginalDocument />
          </Li>
          <Li>
            <Typography>{OVD_Contactable}</Typography>
          </Li>
          <Li>
            <Typography>{OVD_Certificate}</Typography>
          </Li>
          <Li>
            <Typography> {Officially_Valid_Document}</Typography>
          </Li>
        </>
      </Ol>
    </Grid>
  );
};

const OutboundDeclarationText = () => {
  const { application } = useSelector((store: RootStateType) => store.application);
  return (
    <>
      <Ol>
        <>
          <Li>
            <>
              I/We hereby declare that all the information and particulars given by me/us in this
              Application Form and other details and documents submitted are true to the best of
              my/our knowledge and belief. I/We agree to immediately inform you if there is any
              change in any of the information given in this application or in the Annexure(s) to
              this application and/or any other details and documents provided post Application
              Form. I/We declare and agree that if any of the above statements are found to be
              incorrect or false or any information or particulars have been suppressed or omitted
              there from, the FME, inter alia, has the right to ask me/us to withdraw from the
              Scheme or transfer the units held by me/us to a transferee as may be designated by it
              and/or take necessary steps for breach of representation and warranties. I/We also
              agree to furnish such further information as you or IFSCA or any other regulatory
              authority may require from me/us from time to time in relation to the holdings of
              Units of the Scheme and I/we agree that if I/we fail to give such information, you
              shall have the right to and/or return funds and not allot Units and report the same to
              the applicable Regulators. I/We also understand that there is no assurance on the
              returns of the Scheme.
            </>
          </Li>
          <Li>
            <>
              I/We hereby agree and accept that Fund Management Entity (FME), their authorised
              agents, representatives, distributors its settlor, trustees, their em ployees, service
              providers, representatives (‘the Authorised Parties’) are not liable or responsible
              for any losses, costs, damages arising out of any actions undertaken or as a result of
              this investment or activities performed by them on the basis of the information
              provided by me as also due to my not intimating / delay in intimating such changes. I
              authorize the FME to disclose, share, remit in any form, mode or manner, all / any of
              the information provided by me to authorised parties including any of the Indian or
              foreign governmental or statutory or judicial authorities / agencies including
              Financial Intelligence unit India (FIU-IND) without any obligation of advising me/us
              of the same.
            </>
          </Li>
          <Li>
            <>
              I/We understand that if I/we are categorized as high risk investors as per the
              policies / procedures adopted by the FME, additional documents / declarations may be
              sought, which I/We shall promptly provide, in absence of which my/our application may
              be kept on hold.
            </>
          </Li>
          <Li>
            <>
              I/We hereby declare and confirm that the investment as detailed in the accompanying
              application form complies with the provisions of the Foreign Exchange Management Act,
              1999 (FEMA), and the relevant rules, regulations, directions, and guidelines issued
              thereunder by the Reserve Bank of India (RBI) and the Government of India, including
              but not limited to the Foreign Exchange Management (Overseas Investment) Rules, 2022,
              and the Foreign Exchange Manage ment (Overseas Investment) Regulations, 2022, as may
              be amended from time to time. I/We hereby confirm that the Ultimate Beneficial Owner
              (UBO) has been identified and declared in accordance with all applicable laws and
              regulations, and I further acknowledge that it is my sole responsibility to ensure the
              accuracy and completeness of this disclosure. I/We hereby declare and confirm that the
              source of funds for the proposed investment is through permissible means under FEMA
              and does not involve any contravention of the provisions of the FEMA Act. I/We shall
              ensure ongoing compliance with the reporting and disclosure requirements as prescribed
              by the RBI for such overseas investments. I/We undertake to abide by all applicable
              provisions of FEMA and to obtain all necessary approvals, wherever applicable, and to
              report to the RBI/Authorized Dealer as required. I/We hereby declare and confirm that
              all required fil ings, including but not limited to Form FC, Form ODI, and Annual
              Performance Reports (APR), as applicable, will be made in accordance with the
              prescribed timelines. I/We hereby declare and confirm that the proposed investment is
              within the overall limit as prescribed by the RBI from time to time.
            </>
          </Li>
          <Li>
            <>
              I/We hereby accord my/our consent to the FME/Scheme for collecting, receiving,
              possessing, storing, dealing, handling or disclosure of personal data of directors and
              authorized signatories and hereby authorize to disclose it to the third party or
              another body corporate or any person acting under a lawful contract with the FME. I/We
              hereby grant my/our consent to the FME and it’s associates to send all the
              communications/reports on all the email addresses specified in the form.
            </>
          </Li>
          <Li>
            <>
              The FME reserves the right to inform the existing Distributor/Referral Agent of any
              request received from the investors which can directly or indirectly impact the
              Distributors/Referral Agent.
            </>
          </Li>
          <Li>
            <>
              I/We hereby accord my/our consent to Edelweiss Asset Management Limited (IFSC Branch)
              for receiving the promotional information/ material via email, SMS, telemarketing
              calls etc. on the mobile number and email provided by me/us in this Application Form.
              I / We have read, understood & agree to the terms and conditions mentioned in the
              Offer Documents of the {application?.scheme?.schemeName || 'Edelweiss'} as well as the
              rules and regulations of the IFSCA, Prevention of Money Laundering Act and such other
              regulations as may be applicable to me/us from time to time and agree to comply with
              the same as a Unitholder and would like to invest in the Scheme. Further, I / We will
              be bound by the Scheme’s terms and conditions as amended from time to time. I/We also
              confirm that the information provided herein is true, correct, and complete to the
              best of my/our knowledge and belief.
            </>
          </Li>
          <Li>
            <>
              I/We have read the terms and conditions for investment in the Fund and hereby of
              Investment acknowledge the receipt of the Offer Document of{' '}
              {application?.scheme?.schemeName || 'Edelweiss'} dated
            </>
          </Li>
        </>
      </Ol>
    </>
  );
};

export const OutboundDeclaration = () => {
  return (
    <Grid sx={{ width: '100%', mt: 2 }}>
      <SubHeading2>Declarations and Signatures</SubHeading2>
      <OutboundDeclarationText />
    </Grid>
  );
};
